export const navigate = url => parent.window.open(url, '_self')

export const refreshPage = () => window?.location?.reload()
